<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='供应商类型：'>
          <el-input v-model='searchForm.type' size='mini'
                    placeholder='请输入供应商类型' />
        </el-form-item>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.supplierName' size='mini'
                    placeholder='请输入供应商' />
        </el-form-item>
        <el-form-item label='合同编号：'>
          <el-input v-model='searchForm.contractCode' size='mini' placeholder='请输入合同编号' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
          <el-button size='small'  type='danger' @click="btnClick('deletes')">批量删除
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'
        @selection-change='selectionChange'
        :row-style="rowStyle"
      >
        <el-table-column type='selection' align='center' min-width='50' />
        <el-table-column prop='type' label='供应商类型' align='center' min-width='100px' :formatter="getType"/>
        <el-table-column prop='supplierName' label='供应商' align='center' min-width='100px' show-overflow-tooltip/>
        <el-table-column prop='contractCode' label='合同号' align='center' min-width='140px'/>
        <el-table-column prop='contractName' label='合同名称' align='center' min-width='100px'  show-overflow-tooltip/>
        <el-table-column prop='reconciliationTime' label='对账时间' align='center' min-width='100px' show-overflow-tooltip/>
        <el-table-column prop='createBy' label='录入人员' align='center' min-width='80px' />
<!--        <el-table-column prop='startDate' label='开始时间' align='center' min-width='90px' />-->
<!--        <el-table-column prop='endDate' label='结束时间' align='center' min-width='90px' />-->
        <el-table-column prop='state' label='状态' align='center' min-width='100px' :formatter="getState"/>
        <el-table-column label='操作' align='center' min-width='230px'>
          <template slot-scope='scope'>
            <div style='display:flex;align-items:center;padding-left: 10px' class='dynamicWidth'>
              <el-button size='mini' class='searchBtn' type='primary'
                         @click='detailClick(scope.row.id)'>详情
              </el-button>
              <el-button size='mini' type='primary'
                         @click='editBtn(scope.row)' class='yellow-bg'>修改
              </el-button>
              <el-button v-if="scope.row.state == 0 || scope.row.state == 2" size='mini' type='primary'
                         @click='enableClick(scope.row,1)' class='green-bg'>启用
              </el-button>
              <el-button v-if="scope.row.state == 1" size='mini' type='primary'
                         @click='stopClick(scope.row,2)' class='yellow-bg'>停用
              </el-button>
              <el-button  size='mini' type='danger'
                          @click="btnClick('delete', scope.row)">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>
    <addContracts ref="addContractsRef" @searchBtn="searchBtn"/>
    <detailContract ref="detailContractsRef"/>
  </div>
</template>
<script>
import addContracts from '../contractSettlement/components/addContracts.vue'
import detailContract from '../contractSettlement/components/detailContract.vue'
import {
  deleteContract, getContractPageListInfo, updateContractState, updateContractState2, updateState2
} from "@/service/warehouse";
export default {
  components:{addContracts,detailContract},
  data(){
    return{
      searchForm:{
        type: '',
        supplierName: '',
        contractCode: '',
        page: 1,
        rows: 10,
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      selectedData: []
    }
  },
  mounted() {
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
  },
  methods:{
    getType(r, c, cellValue) {
      switch (cellValue) {
        case 0:
          return '公路';
        case 1:
          return '水路';
        case 2:
          return '港口及其他';
      }
    },
    getState(r, c, cellValue) {
      switch (cellValue) {
        case 0:
          return '待启用';
        case 1:
          return '启用中';
        case 2:
          return '已停用';
      }
    },
    //查询
    searchBtn(){
      this.searchForm.page = 1;
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await getContractPageListInfo(this.searchForm);
      this.tableLoading = false;
      if (status !== null) return this.$message.warning(message);
      this.tableData = data.records;
      this.total = data.total;
    },
    //重置
    resetBtn(){
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
    },
    //新增
    addBtn(){
      this.$refs.addContractsRef.dialogOpen('新增')
    },
    //详情
    detailClick(id){
      this.$refs.detailContractsRef.init(id)
    },
    //修改
    editBtn(row){
      this.$refs.addContractsRef.dialogOpen('修改',row)
    },
    //启用
    enableClick(id){
      this.$confirm(`确认启用当前选中数据？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { status, message } = await updateContractState(id);
          if (status !== -1) return this.$message.error(message);
          this.$message.success(message);
          this.searchBtn()
        })
        .catch(() => {});
    },
    //停用
    stopClick(id){
      this.$confirm(`确认停用当前选中数据？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { status, message } = await updateContractState2(id);
          if (status !== -1) return this.$message.error(message);
          this.$message.success(message);
          this.searchBtn()
        })
        .catch(() => {});
    },
    //删除
    btnClick(str, row) {
      switch (str) {
        case 'deletes':
          if (this.selectedData.length === 0) return this.$message.warning('请选择数据后删除！');
          const deleteIds = this.selectedData.map(item => item.id).join(',');
          this.deleteClick(deleteIds);
          break;
        case 'delete':
          this.deleteClick(row.id, str);
          break;
      }
    },
    deleteClick(ids){
      this.$confirm('确认删除当前选中数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const {
            status,
            message,
          } = await deleteContract(ids);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn()
        });
    },
    selectionChange(selection) {
      this.selectedData = selection;
    },
    rowStyle({ row }) {
      return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    //删除
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
    },
  }
}
</script>

<style scoped lang="scss">
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 15px;
  background-color: #fff;

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }

  .content {
    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-top: 10px;

      span {
        font-size: 13px;
      }
    }
  }
}
</style>
